import { useCallback, useEffect, useState } from "react";
import {
  fetchFoodAraStressTest,
  fetchFoodAraSustainabilityReport,
} from "../../../../api/foodApi";
import { FOOD_SOURCE_KEYS } from "../../../../constants/foodSourceConstants";
import AdminTableContainer from "../layout/AdminTableContainer";

const FoodAraCompleteSustainabilitySection = () => {
  const [report, setReport] = useState(null);
  const [stress, setStress] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const load = useCallback(async () => {
    try {
      setLoading(true);
      setErrorMessage("");
      const [sustainability, stressTest] = await Promise.all([
        fetchFoodAraSustainabilityReport({ sourceKey: FOOD_SOURCE_KEYS.ARA_COLOMBIA }),
        fetchFoodAraStressTest({ sourceKey: FOOD_SOURCE_KEYS.ARA_COLOMBIA }),
      ]);
      setReport(sustainability);
      setStress(stressTest);
    } catch (error) {
      setErrorMessage(error.message || "Failed to load sustainability data.");
      setReport(null);
      setStress(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const basket = report?.latestBasketResult;
  const assessment = report?.assessment;

  return (
    <section className="panel-card food-retail-ingestion-page__normalization">
      <div className="food-retail-ingestion-page__section-header">
        <div>
          <h2>ARA COMPLETE Sustainability</h2>
          <p className="muted">
            Weekly operational status and read-only stress-test projections. See{" "}
            <code>docs/food/ARA_COMPLETE_SUSTAINABILITY_RUNBOOK.md</code>.
          </p>
        </div>
        <button type="button" className="btn btn-secondary" onClick={load} disabled={loading}>
          {loading ? "Refreshing…" : "Refresh"}
        </button>
      </div>

      {errorMessage ? <p className="form-error">{errorMessage}</p> : null}
      {loading && !report ? <p className="muted">Loading sustainability report…</p> : null}

      {report ? (
        <>
          <div className="food-retail-ingestion-page__kpi-row">
            <div>
              <span className="muted">Status</span>
              <strong>{basket?.status ?? "—"}</strong>
            </div>
            <div>
              <span className="muted">Coverage</span>
              <strong>
                {basket?.pricedItemCount ?? "—"} / {basket?.totalItemsCount ?? 14}
              </strong>
            </div>
            <div>
              <span className="muted">Risk</span>
              <strong>{assessment?.riskLevel ?? "—"}</strong>
            </div>
            <div>
              <span className="muted">Stress scenarios</span>
              <strong>{stress?.scenarios?.length ?? "—"}</strong>
            </div>
          </div>

          {assessment?.summary ? (
            <p className="muted food-retail-ingestion-page__hint">{assessment.summary}</p>
          ) : null}

          <div className="food-retail-ingestion-page__hint">
            <p className="muted">
              CLI: <code>npm run food:ara:sustainability-report</code> ·{" "}
              <code>npm run food:ara:stress-test</code>
            </p>
          </div>

          {stress?.scenarios?.length ? (
            <AdminTableContainer>
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Scenario</th>
                    <th>Projected</th>
                    <th>Status</th>
                    <th>COMPLETE?</th>
                  </tr>
                </thead>
                <tbody>
                  {stress.scenarios.map((scenario) => (
                    <tr key={scenario.id}>
                      <td>{scenario.title}</td>
                      <td>
                        {scenario.pricedItemCount}/{scenario.basketItemCount} ({scenario.coveragePercent}%)
                      </td>
                      <td>{scenario.status}</td>
                      <td>{scenario.completeTargetMet ? "yes" : "no"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </AdminTableContainer>
          ) : null}
        </>
      ) : null}
    </section>
  );
};

export default FoodAraCompleteSustainabilitySection;
